import styled, { keyframes } from "styled-components";
import { Colors } from "../../shared/colors/colors";

// Animação de slideDown
export const slideDown = keyframes`
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

// Container principal
export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  width: 90vw;
  padding: 0 16px;
  margin-top: 30px;
  margin-left: 45px;
  margin-bottom: 30px;
`;

// Container para os botões de ação acima da tabela
export const ActionContainer = styled.div`
  margin-bottom: 20px;
`;

// Container da tabela


// Container do modal de formulário
export const ModalFormContainer = styled.div`
  border: 1px solid #dee2e6;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: auto;
  position: relative;
  overflow: visible;
`;

// Container do modal de edição
export const EditModalContainer = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 20px;
  max-width: 600px;
  width: 90%;
  margin: 0 auto;
  position: relative;
`;

// Títulos
// export const BlueTitle = styled.h1<{ fontSize?: number, marginBottom?: number }>`
//   margin: 0;
//   width: 100%;
//   max-height: 20px;
//   font-weight: 500;
//   font-size: ${(props) => props.fontSize || 20}px;
//   line-height: 20px;
//   letter-spacing: 0.4px;
//   margin-bottom: ${(props) => props.marginBottom || 18}px;
//   color: ${Colors.primary};
// `;

// Container do título e botão
export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

// Botão de Nova Movimentação
export const NewMovimentacaoButton = styled.button`
  background-color: #1E40AF;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1E3A8A;
  }
`;

// Overlay do modal
export const UserListModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.3s, opacity 0.3s;

  &.active {
    visibility: visible;
    opacity: 1;
  }
`;

export const Bordas = styled.div`
  background-color: white;
  max-width: 600px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  color: #000;
  transition: all 0.3s ease;

  &:hover {
    color: #999;
  }
`;

// Modal de lista de usuários
export const UserListModal = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 30px;
  width: 100%;
  height: auto;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  z-index: 1001;
  position: relative;
  animation: ${slideDown} 0.3s forwards;
`;

// Form Container
export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RowContainer = styled.form`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

// Input Container
export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center; // Centers content vertically
`;

// Label
export const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
`;

// Input
export const StyledInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    border-color: ${Colors.primary};
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

// Select
export const StyledSelect = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    border-color: ${Colors.primary};
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

// Container dos botões do modal
export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

// Container da senha com ícone
export const PasswordContainer = styled.div`
  position: relative;
  width: 100%;
`;

// Botão mostrar/ocultar senha
export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  z-index: 2;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// Switch container
export const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: 10px;
  width: 40%;
`;

// Switch
export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-right: 10px;
`;

// Switch Input
export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: ${Colors.primary};
  }

  &:checked + span:before {
    transform: translateX(20px);
  }
`;

// Switch Span
export const SwitchSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

// Overlay de loading
export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

// Loading GIF
export const LoadingGif = styled.img`
  width: 100px;
  height: 100px;
`;

// Estilos específicos para as linhas da tabela
export const ReativacaoRow = styled.tr`
  background-color: rgba(209, 250, 229, 0.4) !important;
  &:hover {
    background-color: rgba(209, 250, 229, 0.6) !important;
  }
`;

export const ExclusaoRow = styled.tr`
  background-color: rgba(254, 226, 226, 0.4) !important;
  &:hover {
    background-color: rgba(254, 226, 226, 0.6) !important;
  }
`;

export const InclusaoRow = styled.tr`
  background-color: rgba(219, 234, 254, 0.4) !important;
  &:hover {
    background-color: rgba(219, 234, 254, 0.6) !important;
  }
`;

// Células de dados específicas para status
export const StatusCell = styled.td<{ status: 'ativo' | 'inativo' }>`
  padding: 0.75rem 1rem;
  border: 1px solid ${Colors.borderMenu};
  font-weight: 500;
  color: ${props => props.status === 'ativo' ? '#10B981' : '#EF4444'};
`;

// Célula de ações
export const ActionsCell = styled.div`
  gap: 5%;
  display: flex;
  justify-content: center;
`;

// Célula de ações específicas
export const ActionsCellAcoes = styled.div`
  width: 20%;
`;

// Estilo para o ícone de lixeira no botão de deletar
export const DeleteButton = styled.button`
  &:hover .trash-icon {
    transform: scale(1.5);
    color: red;
  }
`;